// Step three: what happened, and what the member should do next.
//
// Used for every terminal state, approved, denied, expired, and "somebody
// already acted on this", because in all four cases the useful information is
// the same shape: what is true now, what it means, and one way onwards.

import { Stack, Text } from "@chakra-ui/react";

import PloyButton from "components/ds/PloyButton";

export type OutcomeProps = {
  lines: string[];
  actionLabel: string;
  onAction: () => void;
};

const Outcome = ({ lines, actionLabel, onAction }: OutcomeProps) => (
  <Stack spacing="lg" w="full">
    <Stack spacing="sm">
      {lines.map((line) => (
        <Text key={line} fontSize="smd" color="neutral.700">
          {line}
        </Text>
      ))}
    </Stack>
    <PloyButton variant="secondary" size="md" onClick={onAction} alignSelf="flex-start">
      {actionLabel}
    </PloyButton>
  </Stack>
);

export default Outcome;
